import {
  FulfillmentMethod,
  Status,
  StatusValue,
  Weekday,
} from 'lib/store/offers/types';

export const PAGINATION_DEFAULT = 1;
export const PAGINATION_PER_PAGE = 6;

export const DAYS_OF_WEEK = Weekday;

export const PROGRESS_STEP_NONE = -1;
export const PROGRESS_STEP_CREATE = 0;
export const PROGRESS_STEP_EDIT = 0;
export const PROGRESS_STEP_REVIEW = 1;
export const PROGRESS_STEP_KEYS = ['details', 'review'];

export const OFFER_STATE_SCHEDULED: StatusValue = Status.SCHEDULED;
export const OFFER_STATE_LIVE: StatusValue = Status.LIVE;
export const OFFER_STATE_PAUSED: StatusValue = Status.PAUSED;
export const OFFER_STATE_ENDED: StatusValue = Status.ENDED;
export const OFFER_STATE_CANCELLED: StatusValue = Status.CANCELLED;
export const OFFER_CANCELABLE_STATES = [
  OFFER_STATE_LIVE,
  OFFER_STATE_PAUSED,
  OFFER_STATE_SCHEDULED,
];
export const OFFER_STATES: StatusValue[] = [
  OFFER_STATE_SCHEDULED,
  OFFER_STATE_LIVE,
  OFFER_STATE_ENDED,
  OFFER_STATE_CANCELLED,
];

// TODO(jlo): replace the client-side statuses above with these.
export const OFFER_API_STATE_ACTIVE = 'active';
export const OFFER_API_STATES = [
  'active',
  'paused',
  'scheduled',
  'expired',
  'cancelled',
] as const;

export const START_DATE_OFFSET_DAYS = 3;
export const REPORT_LEAD_TIME_DAYS = 7;

// This is temporary; we will have a full T&Cs page at a later stage.
export const TERMS_AND_CONDITIONS_URL =
  'https://restaurants.deliveroo.com/en-gb/terms#marketer-terms-and-conditions';

export const TERMS_AND_CONDITIONS_URL_AE =
  'https://restaurants.deliveroo.com/en-ae/terms#marketer-terms-and-conditions';

export const TERMS_AND_CONDITIONS_URL_IT =
  'https://restaurants.deliveroo.com/it-it/terms#marketer-termini-e-condizioni';

export const TERMS_AND_CONDITIONS_URL_NL =
  'https://restaurants.deliveroo.com/nl-nl/terms#algemene-voorwaarden-voor-marketeers';

export const TERMS_AND_CONDITIONS_URL_FR =
  'https://restaurants.deliveroo.com/fr-fr/terms#conditions-générales-marketerxs';

export const TERMS_AND_CONDITIONS_URL_KW =
  'https://restaurants.deliveroo.com/en-kw/terms#marketer-terms-and-conditions';

export const TERMS_AND_CONDITIONS_URL_AU =
  'https://restaurants.deliveroo.com/en-au/terms#marketer-terms-and-conditions';

export const TERMS_AND_CONDITIONS_URL_ES =
  'https://restaurants.deliveroo.com/es-es/terms#términos-y-condiciones-de-marketer';

export const TERMS_AND_CONDITIONS_URL_SG =
  'https://restaurants.deliveroo.com/en-sg/terms#marketer-terms-and-conditions';

export const TERMS_AND_CONDITIONS_URL_BE =
  'https://restaurants.deliveroo.com/fr-be/terms#conditions-générales-marketer';

export const TERMS_AND_CONDITIONS_URL_HK =
  'https://restaurants.deliveroo.com/zh-hk/terms#marketer-terms-and-conditions';

export const OFFER_DURATIONS = [1, 3, 5, 7, 14];
export const OFFER_START_HOUR = 9;

export const OFFER_FULFILLMENT_METHOD_DELIVERY = FulfillmentMethod.DELIVERY;
export const OFFER_FULFILLMENT_METHOD_PICKUP = FulfillmentMethod.COLLECTION;
export const OFFER_FULFILLMENT_METHOD_DINE_IN = FulfillmentMethod.DINE_IN;
export const OFFER_FULFILLMENT_METHODS = [
  OFFER_FULFILLMENT_METHOD_DELIVERY,
  OFFER_FULFILLMENT_METHOD_PICKUP,
  OFFER_FULFILLMENT_METHOD_DINE_IN,
];
